export enum ConnectionType {
    Tariff = 1,
    Arena = 2,
    Market = 3,
    Orpheo = 5,
    ClubISD = 6,
    SyntechParking
}
